import { Cliente } from './cliente.model';
import { Usuario } from './usuario.model';

export class UsuarioCliente {
  id?: number = undefined;

  usuario?: Usuario;
  cliente?: Cliente;
}
